import { call, put, select, takeLatest } from 'redux-saga/effects'
import { PcrDocsService } from '../../../../services/pcrDocs.service'
import { getPcrIdSelector } from '../../../home/selectors'
import { throwPcrException } from '../../../pcr/store/pcr.actions'
import { IPcr } from '../../../pcr/store/pcr.types'
import { getServiceIdSelector } from '../../../user/selectors'
import { getTitrateSelector } from '../selectors'
import { saveTitrate } from '../store/titrate.actions'
import { ITitrateState } from '../store/titrate.types'
import { TitrateConstants } from '../store/titrate.constants'
import { performWithMutexHOG } from '../../../../services/mutexUtility.service'

export function* setComments() {
  const titrateState: ITitrateState = yield select(getTitrateSelector)
  const { comments } = titrateState
  const serviceId: string = yield select(getServiceIdSelector)
  const pcrDocsService = new PcrDocsService(serviceId)
  const pcrID: string = yield select(getPcrIdSelector)
  if (pcrID) {
    try {
      const pcrDoc: IPcr = yield call([pcrDocsService, pcrDocsService.getPCR], pcrID)
      if (pcrDoc.patient?.titrateStateList && pcrDoc.patient?.titrateStateList.length) {
        const index = pcrDoc.patient?.titrateStateList?.findIndex((titrate) => titrate.key === titrateState.key)
        if (index !== -1) {
          if (pcrDoc.patient.titrateStateList[index].comments !== comments) {
            yield put(saveTitrate())
          }
        }
      } else {
        yield put(saveTitrate())
      }
    } catch (e) {
      yield put(throwPcrException(`setComments Titrate() error: ${e}`))
    }
  } else {
    // todo: add to audit log
  }
}

export function* setCommentsSaga() {
  yield takeLatest([TitrateConstants.SET_COMMENTS], performWithMutexHOG, setComments)
}
